import { Button } from '@mantine/core'
import ButtonClasses from './styles.module.css'

export default Button.extend({
    defaultProps: { radius: 'xl', size: 'sm' },
    classNames: ButtonClasses,
})
